import moment from "moment";
import i18n from "~/i18n";

export const steps = ["daily", "weekly", "monthly", "quarterly", "yearly", "custom", "all"];

export const defaultStep = "daily";

export const getStepVerbose = (step) => {
  switch (step) {
    case "daily":
      return i18n.t("Daily");
    case "weekly":
      return i18n.t("Weekly");
    case "monthly":
      return i18n.t("Monthly");
    case "quarterly":
      return i18n.t("Quarterly");
    case "yearly":
      return i18n.t("Yearly");
    case "all":
      return i18n.t("All");
    case "custom":
      return i18n.t("Custom");
    default:
      break;
  }
};

export const getStepDates = (step, firstWeekDay, customFrom, customTo) => {
  const timezone = moment.defaultZone ? moment.defaultZone.name : moment.tz.guess();
  const currentDateInTimezone = moment().tz(timezone).format("YYYY-MM-DD");
  const today = moment.utc(currentDateInTimezone);

  const dates = {
    from: today,
    to: today,
  };

  switch (step) {
    case "daily": {
      break;
    }
    case "weekly": {
      const week = firstWeekDay === 0 ? "week" : "isoWeek";
      dates.from = today.clone().startOf(week);
      dates.to = today.clone().endOf(week);
      break;
    }
    case "monthly": {
      dates.from = today.clone().startOf("month");
      dates.to = today.clone().endOf("month");
      break;
    }
    case "quarterly": {
      dates.from = today.clone().startOf("quarter");
      dates.to = today.clone().endOf("quarter");
      break;
    }
    case "yearly": {
      dates.from = today.clone().startOf("year");
      dates.to = today.clone().endOf("year");
      break;
    }
    case "custom": {
      dates.from = moment(customFrom);
      dates.to = moment(customTo);
      break;
    }
  }

  return dates;
};
